import axios from '@axios'

const state = () => ({
  pendingCount: 0,
})

const getters = {
  pendingCount: state => state.pendingCount,
}

const mutations = {
  SET_PENDING_COUNT(state, count) {
    state.pendingCount = Number(count) || 0
  },
}

const actions = {
  async fetchMaterialSuggestions({ commit }, {
    status = 'pending', name = '', page = 1, perPage = 25,
  } = {}) {
    const response = await axios.get('/v1/material_suggestions', {
      params: {
        by_status: status,
        by_name: name || undefined,
        meta: { pagination: { page, per_page: perPage } },
      },
    })
    commit('SET_PENDING_COUNT', response.data?.meta?.pending)
    return response.data
  },

  async fetchPendingCount({ commit }) {
    const response = await axios.get('/v1/material_suggestions/pending_count', { skipErrorToast: true })
    commit('SET_PENDING_COUNT', response.data?.pending)
    return response.data
  },

  async approveMaterialSuggestion({ dispatch }, { id, product }) {
    const response = await axios.post(`/v1/material_suggestions/${id}/approve`, { product_catalog: product })
    dispatch('fetchPendingCount')
    return response.data
  },

  async linkMaterialSuggestion({ dispatch }, { id, productCatalogId, note = '' }) {
    const response = await axios.post(`/v1/material_suggestions/${id}/link`, { product_catalog_id: productCatalogId, note })
    dispatch('fetchPendingCount')
    return response.data
  },

  async rejectMaterialSuggestion({ dispatch }, { id, note = '' }) {
    const response = await axios.post(`/v1/material_suggestions/${id}/reject`, { note })
    dispatch('fetchPendingCount')
    return response.data
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
